<template>
    <header
        class="card-header collapsibleCardHeader"
        :class="{ 'is-clickable': canOpen, 'is-mobile': isMobile }"
        @click="emitClick"
    >
        <div class="card-header-title">
            <div class="level" :class="{ 'is-mobile': isMobile }">
                <div class="collapsibleCardHeader__content">
                    <div class="collapsibleCardHeader__label">
                        <span><slot /></span>
                    </div>
                    <div v-if="isMobile && $slots.items" class="collapsibleCardHeader__items-mobile">
                        <slot name="items" />
                    </div>
                </div>

                <div v-if="!isMobile" class="level-right">
                    <slot name="items" />
                </div>

                <div
                    v-if="icon"
                    class="level-item collapsibleCardHeader__icon"
                    :class="{ 'is-clickable': iconClickable }"
                    @click.stop="onIconClick"
                >
                    <e-icon :icon="icon" />
                </div>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: 'CollapsibleCardHeader',

    props: {
        canOpen: {
            type: Boolean,
            default: true,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
        open: {
            type: Boolean,
            default: false,
        },
        fallbackIcon: {
            default: null,
            type: String,
        },
        iconClickable: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['click', 'icon-click'],

    computed: {
        /**
         * @return {string|boolean}
         */
        icon() {
            if (this.canOpen) {
                return this.open ? 'angle-up' : 'angle-down';
            }

            if (this.fallbackIcon) return this.fallbackIcon;

            return false;
        },
    },

    methods: {
        emitClick() {
            this.$emit('click');
        },

        onIconClick() {
            if (!this.iconClickable) {
                return;
            }

            this.$emit('icon-click');
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'resources/scss/toolbox.scss';

.collapsibleCardHeader {
    .level {
        justify-content: space-between;
        align-items: center;
    }

    .level-item {
        flex-grow: 0 !important;
    }

    &__content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    &__label {
        font-weight: 600;
    }

    &__items-mobile {
        font-size: 0.875rem;
        color: #666;
    }

    &__icon {
        margin-left: auto;
        flex-shrink: 0;
        display: flex;
        align-items: center;
    }

    &.is-mobile {
        .level {
            display: flex;
            flex-direction: row;
            align-items: center;
        }

        .collapsibleCardHeader__content {
            flex: 1;
            margin-right: 16px;
            align-items: flex-start;
            justify-content: center;
        }

        .collapsibleCardHeader__icon {
            align-self: center;
            margin-left: 0;
        }
    }

    &:not(.is-mobile) {
        .level {
            @include until($tablet) {
                display: flex;
                flex-direction: column;
                text-align: center;
            }
        }

        .collapsibleCardHeader__content {
            @include from($tablet) {
                flex-direction: row;
                align-items: center;
                gap: 12px;
            }
        }

        .collapsibleCardHeader__icon {
            @include until($tablet) {
                order: 99;
                margin-bottom: 0 !important;
                margin-top: $column-gap;
            }

            @include from($tablet) {
                margin-left: auto;
            }
        }

        .level-right {
            @include from($tablet) {
                margin-left: 12px;
            }
        }
    }
}
</style>
